export const COUNTRY_NL = {
  AT: "Oostenrijk", BE: "België", BG: "Bulgarije", CH: "Zwitserland", CZ: "Tsjechië", DE: "Duitsland",
  DK: "Denemarken", EE: "Estland", ES: "Spanje", FI: "Finland", FR: "Frankrijk", GB: "Verenigd Koninkrijk",
  GR: "Griekenland", HR: "Kroatië", HU: "Hongarije", IE: "Ierland", IT: "Italië", LI: "Liechtenstein",
  LT: "Litouwen", LU: "Luxemburg", LV: "Letland", MC: "Monaco", MD: "Moldavië", ME: "Montenegro",
  MK: "Noord-Macedonië", NL: "Nederland", NO: "Noorwegen", PL: "Polen", PT: "Portugal", RO: "Roemenië",
  RS: "Servië", SE: "Zweden", SI: "Slovenië", SK: "Slowakije", AL: "Albanië", AD: "Andorra",
  BA: "Bosnië-Herzegovina", TR: "Turkije", UA: "Oekraïne", IS: "IJsland", MA: "Marokko", XK: "Kosovo",
  SM: "San Marino", US: "Verenigde Staten", CA: "Canada", GE: "Georgië", BY: "Belarus",
};

const EURO = ["AT", "BE", "CY", "DE", "EE", "ES", "FI", "FR", "GR", "HR", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PT", "SI", "SK", "AD", "MC", "SM", "VA", "XK", "ME"];

export const COUNTRY_CURRENCY = {
  ...Object.fromEntries(EURO.map((cc) => [cc, "EUR"])),
  CH: "CHF", LI: "CHF", HU: "HUF", CZ: "CZK", PL: "PLN", DK: "DKK", SE: "SEK", NO: "NOK",
  GB: "GBP", BG: "BGN", RO: "RON", RS: "RSD", BA: "BAM", MK: "MKD", AL: "ALL", TR: "TRY",
  IS: "ISK", UA: "UAH", MD: "MDL", BY: "BYN", GE: "GEL", MA: "MAD", US: "USD", CA: "CAD",
};

export const CURRENCY_NAMES = {
  EUR: "Euro", USD: "Amerikaanse dollar", GBP: "Britse pond", CHF: "Zwitserse frank",
  HUF: "Hongaarse forint", CZK: "Tsjechische kroon", PLN: "Poolse zloty", DKK: "Deense kroon",
  SEK: "Zweedse kroon", NOK: "Noorse kroon", RON: "Roemeense leu", BGN: "Bulgaarse lev",
  RSD: "Servische dinar", BAM: "Bosnische mark", MKD: "Macedonische denar", ALL: "Albanese lek",
  TRY: "Turkse lira", ISK: "IJslandse kroon", UAH: "Oekraïense hryvnia", MDL: "Moldavische leu",
  BYN: "Belarussische roebel", GEL: "Georgische lari", MAD: "Marokkaanse dirham",
  CAD: "Canadese dollar", AUD: "Australische dollar", JPY: "Japanse yen", CNY: "Chinese yuan",
};

export const VIGNETTES = {
  AT: { name: "Digitale vignet (ASFINAG)", price: "±€12,50 (10 dagen)", url: "https://shop.asfinag.at/" },
  CH: { name: "E-vignet", price: "CHF 40 (jaarvignet)", url: "https://via.admin.ch/shop/dashboard" },
  SI: { name: "E-vinjeta (DARS)", price: "±€16 (7 dagen)", url: "https://evinjeta.dars.si/" },
  HU: { name: "E-Matrica", price: "±€15 (10 dagen, D1)", url: "https://ematrica.nemzetiutdij.hu/" },
  CZ: { name: "E-dálniční známka", price: "±270 CZK / €11 (10 dagen)", url: "https://edalnice.cz/" },
  SK: { name: "eZnámka", price: "±€12 (10 dagen)", url: "https://eznamka.sk/" },
  BG: { name: "E-vignette (BGTOLL)", price: "±€8 (weekvignet)", url: "https://www.bgtoll.bg/" },
  RO: { name: "Rovinietă", price: "±€6 (7 dagen)", url: "https://www.erovinieta.ro/" },
};

export const TOLL_COUNTRIES = ["FR", "IT", "ES", "PT", "HR", "PL", "GR"];
